module.exports = __webpack_public_path__ + "img/title-3.e3ad8305.png";